
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full Name List of "Saraswati" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full Name List of "Saraswati" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: '108 names of Saraswati, Saraswati Namavali in Sanskrit, Saraswati Namavali with meanings, Goddess Saraswati names chanting, Saraswati names for puja, Saraswati Namavali, 108 names of Goddess Saraswati list'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'108 names of Saraswati, Saraswati Namavali in Sanskrit, Saraswati Namavali with meanings, Goddess Saraswati names chanting, Saraswati names for puja, Saraswati Namavali, 108 names of Goddess Saraswati list, 108 names of saraswati, सरस्वती के 108 नाम'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/namavali/saraswati.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/namavali/saraswati.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Saraswati 108 Namavali | 108 Namavali - सरस्वती 108 नामावली(108 नामावली)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/namavali/saraswati"
        },
        "headline": "Saraswati 108 Namavali - सरस्वती 108 नामावली(108 नामावली)",
        "name" : "Saraswati 108 Namavali - 108 Namavali",
        "description": "Explore the full Name List of 'Saraswati' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/namavali/saraswati.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  